import {Form, Input, InputNumber, message, ModalProps} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import {useMutation} from 'react-query';
import {
    saveCustomerServiceMenu,
    ServiceMenuProps,
    ServiceSetting,
} from '../../../../../service';
import {useDict} from '../../../../../dict';
import {ProModal} from '../../../../../../../../Components/ProModal';
import {UploadSinglePhoto} from '../../../../../../../../Features/Upload/UploadSinglePhoto';
import {SimpleSwitch} from '../../../../../../../../Features/Fields/SimpleSwitch';
import SelectDict from '../../../../../../../../Features/Select/SelectDict';
import RulesAntd from '../../../../../../../../Utils/rulesAntd';
import {IconType} from '../../../../../../../../Utils/publicEnum';
import FormIconSelect from '../../../../../../../../Components/FormComponents/FormIconSelect';
import {LevelType} from '../../../../../../../Service/ServiceAll/service';

interface Props extends ModalProps {
    serviceDetailId: string;
    customerId: string;
    defaultData?: ServiceMenuProps;
    onOk: () => void;
}

const Index = ({
    customerId,
    defaultData,
    onOk,
    serviceDetailId,
    ...props
}: Props) => {
    const [form] = Form.useForm<ServiceSetting>();
    const dict = useDict();

    const onSave = useMutation({
        mutationFn: saveCustomerServiceMenu,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const iconType = Form.useWatch('iconType', form);
    const levelType = Form.useWatch('levelType', form) as LevelType;

    return (
        <ProModal
            {...props}
            title="编辑菜单"
            width={800}
            onOk={form.submit}
            okButtonProps={{loading: onSave.isLoading}}>
            <div className={Style.root}>
                {defaultData && (
                    <Form
                        labelCol={{span: 6}}
                        wrapperCol={{span: 15}}
                        form={form}
                        initialValues={{
                            ...defaultData,
                            serviceCode: defaultData?.code,
                        }}
                        onFinish={formData =>
                            onSave.mutate({
                                ...formData,
                                id: defaultData?.id!,
                                customerId,
                                serviceDetailId,
                            })
                        }>
                        <Form.Item
                            name="name"
                            label="名称"
                            rules={[RulesAntd.Required]}>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="serviceCode"
                            label="编码"
                            rules={[RulesAntd.Required]}>
                            <Input disabled />
                        </Form.Item>
                        <Form.Item
                            name="levelType"
                            label="级别"
                            rules={[RulesAntd.Required]}>
                            <SelectDict disabled options={dict.MenuType.data} />
                        </Form.Item>
                        {[LevelType.Menu, LevelType.H5Menu].includes(
                            levelType,
                        ) && (
                            <Form.Item
                                name="menuUrl"
                                label="url"
                                rules={[RulesAntd.Required]}>
                                <Input />
                            </Form.Item>
                        )}
                        <Form.Item name="status" label="状态">
                            <SimpleSwitch />
                        </Form.Item>
                        <Form.Item
                            name="manageShowType"
                            initialValue="0"
                            label="管理端展示">
                            <SimpleSwitch />
                        </Form.Item>
                        <Form.Item name="iconType" label="图标类型">
                            <SelectDict
                                options={dict.IconType.data}
                                onSelect={() =>
                                    form.setFieldValue('h5Icon', null)
                                }
                            />
                        </Form.Item>
                        {[IconType.Antd, IconType.AntdMobile].includes(
                            iconType,
                        ) && (
                            <Form.Item
                                name="h5Icon"
                                label="图标"
                                tooltip="颜色仅供参考">
                                <FormIconSelect iconType={iconType} />
                            </Form.Item>
                        )}
                        {[IconType.WebSvg, IconType.WebImg].includes(
                            iconType,
                        ) && (
                            <Form.Item
                                name="h5Icon"
                                label="图标"
                                tooltip="颜色仅供参考">
                                <UploadSinglePhoto />
                            </Form.Item>
                        )}
                        <Form.Item name="h5Sort" label="移动端排序">
                            <InputNumber />
                        </Form.Item>
                        <Form.Item name="h5ShowType" label="H5/校友展示">
                            <SelectDict options={dict.H5ShowType.data} />
                        </Form.Item>
                        <Form.Item name="description" label="说明">
                            <Input.TextArea />
                        </Form.Item>
                    </Form>
                )}
            </div>
        </ProModal>
    );
};

export default Index;
